
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"m1.6897 12.497c-.41409.5325-.779126 1.1014-1.090632 1.6997h-.009113c-.04557.0896-.09114.2263.018227.2826.047179.0203.099888.0238.149358.01.049469-.0138.092715-.0442.122541-.086.594409-.6051 1.303679-1.0855 2.086199-1.4128.78252-.3274 1.62253-.4951 2.47076-.4935h6.56806c2.0011.002 3.9751-.4624 5.7654-1.3562s3.3477-2.19257 4.5486-3.79319c.4141-.53251.7791-1.10142 1.0906-1.69975.0456-.08962.0911-.22633-.0182-.28253-.0475-.02013-.1003-.02358-.15-.00979-.0497.0138-.0932.04402-.1234.08574-.593.60405-1.3006 1.08377-2.0812 1.4111s-1.6187.49569-2.4652.49523h-6.5666c-2.0012-.00189-3.97534.46249-5.76588 1.3563-1.79054.89382-3.34821 2.19249-4.54952 3.79309zm21.5515-2.98941c.0497-.01407.1027-.01086.1503.00912.1093.05468.0638.19443.0182.28405-.3125.59684-.6774 1.16464-1.0906 1.69674-1.2008 1.6012-2.7584 2.9004-4.549 3.7945s-3.765 1.3585-5.7665 1.3563h-6.56656c-.84719.0005-1.68581.1698-2.4669.4979-.7811.328-1.48902.8084-2.082465 1.413-.030188.0414-.073438.0714-.122769.0852-.049332.0138-.101868.0105-.14913-.0092-.109367-.0562-.062278-.1944-.018227-.2841.317892-.5938.682051-1.1616 1.089111-1.6982.93114-1.2881 2.30886-2.1266 3.75038-2.1266h6.56656c6.1504 0 10.4537-4.2623 11.1145-4.93212.03-.04199.0734-.07251.1231-.08659z","fill":"#b2895f","fill-rule":"evenodd"}})])
          )
        }
      }
    